module.exports = __webpack_public_path__ + "static/model-trophy-e7e366ed2fee5053a92c095eef47fb1a.png";